var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { api } from "../../services/http.service";
import { env } from "../../constants/global.constants";
import { dateTimeFormat, getAllGames, gameNameFixer, loadingAnimation, ServerDate, slugify } from "../../services/misc.functions";
import { OrderHistoryMenu } from "./account";
import { useNavigate, useParams } from "react-router";
import { isMobile } from "../../App";
import paths from "../../paths";
import "./account.css";
var gameTypes = {
    esyapiyangosu: {
        name: "Eşya Piyangosu",
        type: 5,
        code: "esyapiyangosu",
    },
    puankazan: {
        name: "Kazı Kazan",
        type: 7,
        code: "kazi_kazan",
    },
    supertombala: {
        name: "Süper Tombala",
        type: 12,
        code: "super_tombala",
    },
    zeplin: {
        name: "Zeplin",
        type: 15,
        code: "zeplin",
    },
    atestoplari: {
        name: "Ateş Topları",
        type: 23,
        code: "9044",
    },
    carkifelek: {
        name: "Çarkıfelek",
        type: 20,
        code: "carkifelek",
    },
    meyvekulesi: {
        name: "Meyve Kulesi",
        type: 18,
        code: "9053",
    },
    taskagitmakas: {
        name: "Taş Kağıt Makas",
        type: 26,
        code: "taskagitmakas",
    },
    galaksituru: {
        name: "Galaksi Turu",
        type: 28,
        code: "9037",
    },
    isiltilitaslar: {
        name: "Işıltılı Taşlar",
        type: 30,
        code: "9050",
    },
    superplinko: {
        name: "Süper Plinko",
        type: 32,
        code: "9047",
    },
    kunduzunmacerasi: {
        name: "Kunduzun Macerası",
        type: 34,
        code: "9043",
    },
};
var getGameSlugs = function () { return __awaiter(void 0, void 0, void 0, function () {
    var games, gameSlugs;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getAllGames()];
            case 1:
                games = _a.sent();
                gameSlugs = [];
                gameSlugs.push({
                    name: "Eşya Piyangosu",
                    slug: "esyapiyangosu",
                    type: 5,
                    code: "esyapiyangosu",
                });
                gameSlugs.push.apply(gameSlugs, games.map(function (game) {
                    var hasType = Object.values(gameTypes).find(function (type) { return type.code === game.code; });
                    return {
                        name: gameNameFixer(game.name),
                        slug: slugify(game.name
                            .toLowerCase()
                            .replaceAll("ü", "u")
                            .replaceAll("ş", "s")
                            .replaceAll("ç", "c")
                            .replaceAll("ğ", "g")
                            .replaceAll("ı", "i")
                            .replaceAll("ö", "o")),
                        type: hasType ? hasType.type : game.type,
                        code: game.code,
                    };
                }));
                return [2 /*return*/, gameSlugs];
        }
    });
}); };
export function AccountOrderHistory() {
    var _this = this;
    var _a, _b;
    var _c = useState([]), gameSlugs = _c[0], setGameSlugs = _c[1];
    useEffect(function () {
        getGameSlugs().then(function (res) {
            setGameSlugs(res);
        });
    }, []);
    var params = useParams();
    var _d = useState(null), dataList = _d[0], setDataList = _d[1];
    var _e = useState(0), page = _e[0], setPage = _e[1];
    var navigate = useNavigate();
    var today = ServerDate();
    var _f = useState({
        start_date: today.toISOString().slice(0, 10) + "T00:00:00",
        end_date: today.toISOString().slice(0, 10) + "T23:59:59",
    }), filter = _f[0], setFilter = _f[1];
    useEffect(function () {
        setPage(0);
        loadData(0);
    }, [params === null || params === void 0 ? void 0 : params.id, filter]);
    var loadData = function (forcePage) {
        if (forcePage === void 0) { forcePage = null; }
        return __awaiter(_this, void 0, void 0, function () {
            var pageN, payload, pathname;
            var _a, _b;
            return __generator(this, function (_c) {
                loadingAnimation(true);
                pageN = forcePage !== null ? forcePage : page;
                if (pageN === 0 && dataList && dataList.length > 0) {
                    setDataList([]);
                }
                payload = {
                    page: pageN,
                    game_code: (_a = gameSlugs.find(function (game) { return game.slug === (params === null || params === void 0 ? void 0 : params.id); })) === null || _a === void 0 ? void 0 : _a.code,
                    game_type: (_b = gameSlugs.find(function (game) { return game.slug === (params === null || params === void 0 ? void 0 : params.id); })) === null || _b === void 0 ? void 0 : _b.type,
                };
                if (filter) {
                    payload["create_date_from"] = filter["start_date"];
                    payload["create_date_to"] = filter["end_date"];
                }
                pathname = window.location.pathname;
                api
                    .start("post", env.accounting_api +
                    (pathname.includes("esyapiyangosu") || pathname.includes("puankazan")
                        ? "/somos/api/list-coupon/"
                        : "/games/api/list-coupon/"), payload, true)
                    .then(function (res) {
                    loadingAnimation(false);
                    var tmp = [];
                    if (res && res.status) {
                        if (pageN === 0 && dataList && dataList.length > 0) {
                            dataList.splice(0, dataList.length);
                            tmp.push.apply(tmp, res.data);
                        }
                        else {
                            if (dataList === null) {
                                tmp.push.apply(tmp, res.data);
                            }
                            else {
                                tmp = __spreadArray([], dataList, true);
                                tmp.push.apply(tmp, res.data);
                            }
                        }
                        if (res && res.metadata) {
                            var id_datalist_loadmore = document.getElementById("id_datalist_loadmore");
                            if (res.metadata.count === 0 || res.metadata.count <= tmp.length) {
                                id_datalist_loadmore.style.display = "none";
                            }
                            else {
                                id_datalist_loadmore.style.display = "unset";
                            }
                        }
                        setDataList(tmp);
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    var loadMore = function (e) {
        e.target.disabled = true;
        var nPage = page + 1;
        setPage(nPage);
        loadData(nPage).finally(function () {
            e.target.disabled = false;
        });
    };
    var _g = useForm(), register = _g.register, handleSubmit = _g.handleSubmit, reset = _g.reset, errors = _g.formState.errors;
    var onSubmit = function (data) {
        var startDate = new Date(today);
        startDate.setDate(startDate.getDate() - Number(data.date));
        setPage(0);
        setDataList([]);
        var _filter = {
            start_date: startDate.toISOString().slice(0, 10) + "T00:00:00",
        };
        if (Number(data.date) == 0 || Number(data.date) == 1) {
            _filter.end_date = startDate.toISOString().slice(0, 10) + "T23:59:59";
        }
        setFilter(_filter);
    };
    if (!(params === null || params === void 0 ? void 0 : params.id) || !gameSlugs.find(function (game) { return game.slug === (params === null || params === void 0 ? void 0 : params.id); })) {
        setTimeout(function () {
            navigate(paths.account.url + "/islem-gecmisim/esyapiyangosu/");
        }, 1000);
        return _jsx(_Fragment, {});
    }
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "row mt-3" }, { children: [_jsxs("div", __assign({ className: "col-3 col-mobile-12" }, { children: [_jsxs("div", __assign({ className: "account-info-container" }, { children: [_jsx("div", __assign({ className: "account-info-header" }, { children: _jsx("div", __assign({ className: "account-info-header-text" }, { children: "F\u0130LTRELE" })) })), _jsx("div", __assign({ className: "account-info-main" }, { children: _jsx("form", __assign({ onSubmit: handleSubmit(onSubmit), className: "account-info-form" }, { children: _jsxs("div", __assign({ className: "account-info-section" }, { children: [_jsxs("div", __assign({ className: "account-info-field" }, { children: [_jsx("div", __assign({ className: "account-info-label" }, { children: "Tarih Aral\u0131\u011F\u0131" })), _jsxs("div", __assign({ className: "account-info-input-container" }, { children: [_jsx("div", { className: "account-info-input-bg" }), _jsxs("select", __assign({ className: "account-info-select" }, register("date"), { children: [_jsx("option", __assign({ value: 7 }, { children: "Son 1 Hafta" })), _jsx("option", __assign({ value: 0, selected: true }, { children: "Bug\u00FCn" })), _jsx("option", __assign({ value: 1 }, { children: "D\u00FCn" })), _jsx("option", __assign({ value: 30 }, { children: "Son 30 G\u00FCn" }))] }))] }))] })), _jsx("button", __assign({ className: "account-info-button" }, { children: "G\u00F6ster" }))] })) })) }))] })), !isMobile && _jsx(OrderHistoryMenu, { gameSlugs: gameSlugs })] })), _jsxs("div", __assign({ className: "col-9 col-mobile-12 ".concat(isMobile ? 'account-content-mobile' : '') }, { children: [isMobile && _jsx(OrderHistoryMenu, { gameSlugs: gameSlugs }), _jsxs("div", __assign({ className: "account-info-container" }, { children: [_jsx("div", __assign({ className: "account-info-header" }, { children: _jsxs("div", __assign({ className: "account-info-header-text" }, { children: ["\u0130\u015ELEM GE\u00C7M\u0130\u015E\u0130M - ", (_b = (_a = gameSlugs.find(function (game) { return game.slug === (params === null || params === void 0 ? void 0 : params.id); })) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.toUpperCase()] })) })), _jsx("div", __assign({ className: "account-info-main" }, { children: _jsxs("div", __assign({ className: "account-info-form" }, { children: [dataList && dataList.length > 0 && (_jsx("div", __assign({ className: "account-info-activities" }, { children: dataList.map(function (item, key) {
                                                    return (_jsxs("div", __assign({ className: "account-info-activity-item" }, { children: [_jsxs("div", __assign({ className: "account-info-activity-content" }, { children: [_jsxs("div", __assign({ className: "account-info-activity-message" }, { children: [_jsxs("span", __assign({ className: "account-info-activity-badge info" }, { children: [item.count, " bilet"] })), item.draw__title_abbreviated] })), _jsxs("div", __assign({ className: "account-info-activity-date" }, { children: [item.transaction_date && dateTimeFormat(item.transaction_date), item.approve_date && (_jsxs("div", __assign({ style: { fontSize: '12px', color: '#666' } }, { children: ["Onay: ", dateTimeFormat(item.approve_date)] })))] }))] })), _jsxs("div", __assign({ className: "account-info-activity-details" }, { children: [_jsxs("div", __assign({ className: "account-info-activity-ip" }, { children: [Number(item.total_tl_cost) > 0 && (_jsxs("div", { children: [item.total_tl_cost, " \u20BA"] })), Number(item.total_point_cost) > 0 && (_jsxs("div", { children: [item.total_point_cost, " \u015EP"] }))] })), _jsx("div", __assign({ className: "account-info-activity-agent" }, { children: Number(item.total_won_amount) > 0 ? (_jsxs("div", __assign({ style: { color: '#28a745', fontWeight: 'bold' } }, { children: [item.total_won_amount, " \u015EP"] }))) : (_jsx("div", __assign({ style: { color: '#6c757d' } }, { children: "-" }))) }))] }))] }), "order-history-".concat(key)));
                                                }) }))), dataList && dataList.length === 0 && (_jsx("div", __assign({ className: "account-info-empty" }, { children: "Listede kay\u0131t bulunmuyor." }))), _jsxs("div", __assign({ className: "text-center" }, { children: [_jsx("div", { id: "id_loaderAnimation", className: "account-info-loader" }), _jsx("button", __assign({ id: "id_datalist_loadmore", onClick: loadMore, type: "button", className: "account-info-button" }, { children: "Devam\u0131n\u0131 Y\u00FCkle" }))] }))] })) }))] }))] }))] })) }));
}
